export default "/images/vendor/flag-icon-css/flags/1x1/ng.svg?1b98819eb371ab8889627318ddeaed80";